import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { IconButton, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { styles } from './menu-icon.styles';
const MenuIcon = (props)=>{
    const { classes, dataTestId, icon, items, name, onChange, value } = props;
    return /*#__PURE__*/ _jsxs(Menu, {
        children: [
            /*#__PURE__*/ _jsx(MenuButton, {
                as: IconButton,
                sx: classes?.button ?? styles.button,
                icon: icon,
                "data-testid": dataTestId?.trim() ?? 'menu-icon'
            }),
            /*#__PURE__*/ _jsx(MenuList, {
                sx: styles.list,
                children: items.map((item, key)=>/*#__PURE__*/ _jsx(MenuItem, {
                        sx: item.value === value ? styles.itemSelected : styles.item,
                        value: item.value,
                        name: name ?? item.value.toString(),
                        onClick: onChange,
                        isDisabled: item.disabled,
                        "data-testid": item.value?.toString().trim(),
                        children: item.label
                    }, key))
            })
        ]
    });
};
MenuIcon.displayName = 'MenuIcon';
export { MenuIcon };
